export default "__VITE_ASSET__988b6679__"